import React from 'react'
import PropTypes from 'prop-types'
import useContentAsset from '../../hooks/use-content-asset'
import {Box, Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'

const ContentAsset = ({
    contentAssetId,
    width,
    height,
    skeletonHeight,
    marginBottom,
    skeleton,
    ...rest
}) => {
    const {data: contentAssetBody, isLoading} = useContentAsset(contentAssetId)

    return isLoading ? (
        skeleton ? (
            skeleton()
        ) : (
            <Skeleton height={height || skeletonHeight || 'auto'} width={width || 'auto'} />
        )
    ) : (
        <Box
            className="asset-body"
            data-id={contentAssetId}
            height={height}
            width={width}
            marginBottom={(contentAssetBody && marginBottom) || 0}
            dangerouslySetInnerHTML={{__html: contentAssetBody?.contentAssetHTML}}
            {...rest}
        />
    )
}

ContentAsset.propTypes = {
    contentAssetId: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    skeletonHeight: PropTypes.string,
    marginBottom: PropTypes.string,
    skeleton: PropTypes.any
}

export default ContentAsset
